import React from 'react'
import NavBarHomeDark from '../../../components/NavBar/NavBarHomeDark'
import Breadcrumbs from '../../courses/Breadcrumbs'
import Footer from '../../../components/Footer/Footer'
import MainContent from './MainContent'
import NavBarHome from '../../../components/NavBar/NavBarHome'

function InstructorsList() {
   return (
      <div className="pt-[92px] flex flex-col min-h-screen">
         <NavBarHome />

         <section className='w-full pt-[90px] pb-10'>
            <div className='w-full flex flex-col px-10'>
               <h1 className='text-dark-1 text-[40px] font-semibold dark:text-white'>
                  Nos Tuteurs
               </h1>
               <div>
                  <p className="text-light-1 dark:text-gray-400">
                     Chez GoNextMaker, notre système de tutorat personnalisé accompagne chaque apprenant tout au long de son parcours. Nos tuteurs passionnés favorisent l’autonomie, la créativité et la réussite, grâce à des bootcamps hybrides mêlant présentiel et en ligne pour une expérience d’apprentissage enrichissante.
                  </p>
               </div>
            </div>
         </section>

         <section className='px-24'>
            <MainContent />
         </section>

         <section>
            <Footer
               logo={"/Logo NextMaker.png"}
               bgColor="bg-dark-1"
               textColor="text-gray-100"
               borderColor="border-gray-400/20"
            />
         </section>
      </div>
   )
}

export default InstructorsList